import { RATING_GROUP_All, RATING_GROUP_API } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { fetchratingGroupFailure, fetchratingGroupSuccess } from "./reducer";

export const getAllRatingGroup = (setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${RATING_GROUP_All}`,'GET')
        setLoading(false)
        if (response.error && response.error.code === 'NotFound') {
            dispatch(fetchratingGroupSuccess([]));
        }
        else {
            dispatch(fetchratingGroupSuccess(response.reverse()))
        }
    }
    catch (error) {
        setLoading(false)
        dispatch(fetchratingGroupFailure(error.message))
    }
}